"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeFinishReason = normalizeFinishReason;
const conventions_1 = require("../../conventions");
const json_1 = require("../utils/json");
/**
 * Read the finish/stop carrier off a record (message, choice/candidate, or
 * envelope event) and canonicalize it: anthropic carries `stop_reason`,
 * openai/gemini carry `finish_reason`/`finishReason`, langchain nests both
 * under `response_metadata` (passed as the second carrier).
 */
function normalizeFinishReason(data, responseMetadata) {
    const raw = data.stop_reason ?? // anthropic
        data.finish_reason ??
        data.finishReason ??
        responseMetadata?.finish_reason ?? // langchain
        responseMetadata?.stop_reason; // langchain
    const value = (0, json_1.optionalString)(raw);
    if (!value)
        return undefined;
    // Lookups are lowercased (Gemini reports uppercase values). Registry order
    // must never matter: overlapping vocabulary across providers maps to the
    // same canonical value (asserted by registry.test.ts).
    const lowered = value.toLowerCase();
    const providerType = conventions_1.registeredProviders
        .map((provider) => (0, json_1.ownLookup)(provider.finishReasonTypeByRaw, lowered))
        .find((type) => type !== undefined);
    return { type: providerType ?? "unknown", raw: value };
}
